function getErrorMessages(errorData: any): string {
  if (typeof errorData === 'string') {
    return errorData.replace(/<[^>]*>/g, '');
  } else if (Array.isArray(errorData)) {
    return errorData.map(getErrorMessages).join('\n');
  } else if (typeof errorData === 'object') {
    const values = Object.values(errorData);
    if (values.length > 0) {
      return getErrorMessages(values);
    }
  }
  return 'Произошла ошибка при выполнении запроса.';
}

export default getErrorMessages;
